export const ProductTypeOption = {
  SingleProduct: "SINGLE_PRODUCT",
  ProductVariance: "PRODUCT_VARIANCE",
  ProductBundle: "PRODUCT_BUNDLE",
};
